import { useContext, useState } from 'react';
import { UserInfoContext } from 'reporting-data/userInfo/userInfoContext';
import ErrorBoundaryDecorator from 'reporting-ui-components/reports/decorators/ErrorBoundaryDecorator';
import ReportingAIAssistantContent from './ReportingAIAssistantContent';
import ReportingAIAssistantInsightsContainer from './ReportingAIAssistantInsightsContainer';
import { getIsInsightsShown, getReportDatasetHasNotEnoughDataForAIInsights } from './utils';
import { useFetchReportAIAssistantInsightsWithV2 } from './useFetchReportAIAssistantInsights';
import { jsx as _jsx } from "react/jsx-runtime";
const ReportingAIAssistantInsights = ({
  report,
  reportResolve,
  appUsageTracker,
  showAIBuilder = false
}) => {
  const userInfo = useContext(UserInfoContext);
  const [isInsightsOpen, setInsightsOpen] = useState(false);
  const reportDatasetIsUndefinedOrHasFewerThan1DataPoint = getReportDatasetHasNotEnoughDataForAIInsights(report, reportResolve);
  const useInsightFetchHook = useFetchReportAIAssistantInsightsWithV2();
  const insightFetch = useInsightFetchHook({
    report,
    reportResolve,
    isDeferred: !isInsightsOpen || reportDatasetIsUndefinedOrHasFewerThan1DataPoint
  });
  if (!getIsInsightsShown(report, userInfo) || showAIBuilder) {
    return null;
  }
  return /*#__PURE__*/_jsx(ReportingAIAssistantInsightsContainer, {
    report: report,
    appUsageTracker: appUsageTracker,
    isInsightsOpen: isInsightsOpen,
    setIsInsightsOpen: setInsightsOpen,
    insightFetch: insightFetch,
    children: /*#__PURE__*/_jsx(ReportingAIAssistantContent, {
      appUsageTracker: appUsageTracker,
      report: report,
      reportResolve: reportResolve,
      insightFetch: insightFetch
    })
  });
};
export default ErrorBoundaryDecorator(ReportingAIAssistantInsights, 'ReportingAIInsights');